import {
    TeamOutlined,
} from "@ant-design/icons";

import "./styles.scss";
import { logo_background_thaco } from "../../../components/ExportImgFigma";
import { formatPrice } from "../../../until";

interface StatisticCardProps {

    title: string;

    value: number | string;

    colors: [string, string];

}

const StatisticCard = ({
    title,
    value,
    colors,
}: StatisticCardProps) => {

    return (

        <div

            className="statistic-card"

            style={{

                background: `linear-gradient(90deg, ${colors[0]} 0%, ${colors[1]} 80%)`,

            }}

        >

            <div className="custom-page-css flex flex-col gap-1">

                <div className="text-white text-sm">

                    {title}

                    <TeamOutlined className="custom-page-css pl-2"/>

                </div>

                <div className="text-white text-sm">

                    {formatPrice(value)}

                </div>

            </div>


            <div className="bg-logo">

                <img

                    src={logo_background_thaco}

                    alt="bg"

                />

            </div>

        </div>

    );

};

export default StatisticCard;